import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
    login:{
        logon:"登录",
        system:"系统登录",
        account:"账号",
        password:"密码",
        rules_name:'请输入账号',
        rules_password:'请输入密码',
        account_login:'账号密码登录',
    },
    home:{
        original_password:'原密码',
        new_password:'新密码',
        confirm_password:'确认密码',
        two_passwords:'两次密码不一致',
    },
    index: {
        welcome:'欢迎进入able2shine后台',
        language: "语言",
        dialog_title: "编辑",
        add:"新建",
        add_student:"添加学生",
        edit:"编辑",
        del:"删除",
        hide:"隐藏",
        release:"发布",
        preservation:"保存",
        determine:"确定",
        cancel:"取消",
        submit:"提交",
        logout:"退出登录",
        change_password:"修改密码",
        user_name:"用户名",
        return:"返回",
        sort:"排序",
        operation:"操作",
        admin:"管理员",
        pleaseInput:"请输入",
        cn:'中文',
        en:'英文',
        input:'请输入',
        select:'请选择',
        please:'请检查网络',
        tips:'提示',
        confirm_leave:'确认退出吗？',
        confirm_delete:'确认删除吗？',
        confirm_cancel:'确认取消吗？',
        confirm_kaike:'确定开课并发送开课通知吗？',
        confirm_kaiying:'确定开营并发送开营通知吗？',
        confirm_hide:'确认隐藏吗？',
        hide_success:'隐藏成功',
        delete_success:'删除成功',
        revise_success:'修改成功请使用新密码',
        add_success:'添加成功',
        modify_success:'修改成功',
        operation_success:'操作成功',
        query:'查询',
        reset:'重置',
        whole:'全部',
        image_wu:'无',
        upload:'请上传',
        copy:'复制',
        add_subset:'添加子集',
        export:'导出',
        search:'搜索',
        class_notice:'发送邮件',
        info:'详情',
        copy_success:'复制成功',
        copy_error:'复制失败',
        add_child:'添加学生',
        please_check:'请勾选要操作的数据',
        refund:'退款',
        button:'按钮',
        seller:'绑定销售',
        coupon:'发放优惠券',
        history:'报课记录',
        resend:'重发确认信',
        import:'导入',
        importtemplate:'导入模板',
        in_progress_export:'正在进行中导出',
    },
    system_menu:{
        catalog:'目录',
        menu:'菜单',
        icon:'图标',
        link:'链接',
        secondary_menu:'二级菜单',
        name:'名称',
        code:'标识',
    },
    system_role:{
        role_list:'角色列表',
        role_authorize:'角色授权',
        authorize:'授权',
        select_authorize:'请选择角色进行授权',
        name:'名称',
        show_message:'是否接收虚拟班级消息',
        show_kickback:'是否显示佣金',
    },
    system_admin:{
        user:'账号',
        role:'角色',
        country:'权限',
        re_password:'确认密码',
        password:'密码',
        seller_type:'类型',
        parent:'上级',
        name:'名称',
        tel:'电话号',
        email:'邮箱',
        email_correct:'正确的邮箱地址',
        sale:'销售',
        administrators:'管理员',
        sale_tishi:'（不选就是销售主管）',
        administrators_tishi:'（不选就是课程主管）',
    },
    dictionary:{
        list_name:'字典名称',
        list_code:'字典编码',
        subset_list:'子集列表',
        name:'名称',
        value:'值',
    },
    news_index:{
        type:'文章分类',
        title:'标题',
        description:'描述',
        content:'内容',
        image:'封面图片',
        video:'视频',
        news:'文章所属',
        jump_type:'转跳类型',
        jump_id:'转跳ID',
        cate:'分类',
        is_top:'是否置顶',
    },
    adv_index:{
        title:'标题',
        description:'建议尺寸',
        type:'唯一标识',
        image:'封面图片',
        country:'广告所属',
        message:'请上传图片',
        course_id:'课程ID',
        course_type:'课程类型',
    },
    tidings_index:{
        title:'标题',
        user_type:'类型',
        content:'内容',
        view_details:'查看详情',
        show_time:'发布时间',
    },
    sale_index:{
        name:'姓名',
        email:'邮箱',
        sales_record:'销售记录',
        user_name:'账号',
        country:'销售所属',
        password:'密码',
        re_password:'确认密码',
        user_name3:'账号最少3个字符',
        password3:'密码最少3个字符',
        name3:'姓名最少3个字符',
        id:'订单号',
        subject:'主题',
        price:'单价',
        num:'学生数量',
        discounts:'折扣',
        total:'总价',
    },
    teacher_index:{
        name:'名称',
        thumb:'头像',
        course:'擅长课程',
        description:'描述',
        content:'详细介绍',
        user_name:'账号',
        country:'老师所属',
        password:'密码',
        re_password:'确认密码',
        class_description:'课程中的教师介绍',
        video:'视频',
        facebook:'脸谱网',
        youku:'优酷',
        timetable:'时间表',
        email:'邮箱',
        type:'类型',
    },
    teacher_apply:{
        first_name:'名字',
        last_name:'姓',
        email:'邮箱',
        phone:'手机号',
        nationality:'国籍',
        address:'地址',
        course:'课程',
        subjects:'课程详情',
        history:'教学经验',
        style:'风格',
        resume:'简历',
        file:'查看附件',
        date:'日期时间',
        word_file:'查看简历',
    },
    learning_center:{
        name:'名称',
        address:'地址',
        country:'所属区域',
        address_type:'类型',
        is_show:'是否推荐到首页',
    },
    course_sort:{
        name:'名称',
        subset:'二级分类',
        parent_name:'上一级',
        age_age:'年龄',
        type:'类型',
        binding:'绑定评估表',
        type_active:'显示',
        type_inactive:'输入',
        is_jingsai:'是否是竞赛',
        content:'竞赛说明',
        syllabus:'课程大纲',
        link:'教案链接',
    },
    course_index:{
        theme:'主题',
        session:'学期',
        week:'星期',
        cate:'分类',
        price:'价格',
        price_price:'价格（美元 $）',
        price_type:'价格类型',
        price_type1:'人民币(￥)',
        price_type2:'美元($)',
        max_people:'班级规模',
        teacher:'老师',
        center:'学习中心',
        min_age:'最小年龄',
        max_age:'最大年龄',
        age:'年龄',
        start_date:'开始日期',
        end_date:'结束日期',
        start_time:'开始时间',
        end_time:'结束时间',
        create_time:'创建时间',
        type:'课程类型',
        class_start:'开课',
        camp_start:'开营',
        course_list:'课程安排',
        student_list:'学生列表',
        country:'课程所属',
        date:'日期',
        startdate:'开始日期',
        enddate:'结束日期',
        time:'时间',
        starttime:'开始时间',
        endtime:'结束时间',
        range:'至',
        content:'课堂亮点',
        no_course_dates:'不上课日期',
        title:'名称',
        half_price:'半天学费',
        full_price:'全天学费',
        lunch_price:'午饭费用',
        look_price:'课后看护费用',
        look_price1:'上午课后看护费用',
        look_price2:'下午课后看护费用',
        copy:'复制一周',
        plus:'加一周',
        copy_success:'复制成功',
        sort:'第几周',
        class_num:'总课次',
        power_type:'隐私状态',
        up_0:'下线',
        up_1:'上线',
        list_export:'学生名单导出',
        thumb:'图片',
        early_discount:'早鸟折扣',
        early_time:'早鸟时间',
        introduce:'说明',
        zoom:'zoom链接',
        password:'密码',
        virtual:'虚拟班级',
        status:'状态',
        ongoing:'未开课',
        ongoing_:'未开营',
        upcoming:'已开课',
        upcoming_:'已开营',
        administrators:'管理员',
        youjian_title:'邮件标题',
        xuanzyoujian:'邮件模板',
        xuanzyoujian_info:'邮件模板详情',
        is_show_contact:'是否显示老师交流',
        is_show_evaluation:'是否显示评估表',
        is_show_front:'是否显示再首页',
        show:'显示',
        hide:'隐藏',
        binding_seller:'绑定管理员',
        if_notice:'是否发送开课通知',
        mail_type:'发送类型',
        mail_record:'邮件记录',
        sign_up_list:'报名信息列表',
        add_time:'添加时间',
        field:'字段',
        required:'必填',
        field_name:'字段名称',
        is_must:'是否必填',
        code:'字段只能由大小写字母、数字、下划线组成，不能数字开头',
        form_title:'字段标题',
        add_field:'添加字段',
        buy_course_num:'报名人数',
        sign_up:'是否显示报名',
        year:'年度',
        class:'是否显示私教课',
        record:'操作记录',
        course_edit:'课程编辑',
        noon_price:'午托金额',
        audition_price:'试听金额',
        assistant:'助教',
        sort_sort:'排序',
        remote_course_id:'关联美国课程',
        send_leave_coupon:'请假是否发优惠券',
        yes:'是',
        no:'否',
    },
    parent_index:{
        login_user_name:'学生账号',
        country:'国家',
        referred_email:'推荐人的电子邮件地址',
        referred_tel:'推荐人的电话',
        name:'家长姓名',
        user_name:'账号',
        tel:'电话',
        wechat:'微信',
        province:'城市和州（或省）',
        child:'学生管理',
        order:'订单',
        email:'邮箱',
        user_email:'学生邮箱',
        name_child_cn:'学生中文姓名',
        name_child:'学生英文姓名',
        year:'学生生日',
        thumb:'学生头像',
        seller:'销售',
        integral:'修改积分',
        score_min:'持有积分',
        score:'积分剩余',
        all_get:'总充值积分',
        group_type:'会员等级',
        jiajian:'加或减',
        remarks:'备注',
        coupon_id:'优惠券',
        password:'密码',
        re_password:'确定密码',
        thetwo:'两次密码不一致',
        grade:'年级',
        student_age:'学生年龄',
        trial_substitute:'试听/补课',
        trial_listening:'试听',
        substitute:'补课',
        leave_count:'请假次数',
    },
    order:{
        no:'订单号',
        create_time:'购买时间',
        name:'课程名称',
        children:'学生姓名',
        price:'金额',
        total:'实付金额',
        classes:'退换课',
        teacher:'老师',
        time:'上课时间',
        date:'上课日期',
        on_date:'不上课日期',
        subject:'主题',
        classes_name:'常规课',
        camps:'夏令营',
        customer_name:'客户名称',
        email:'邮件',
        discount:'优惠金额',
        score:'积分',
        refund:'退款金额',
        payment:'支付方式',
        refund_title:'退款金额',
        confirm_delete:'确定退款吗？',
        notes:'备注',
        refund_name:'退款记录',
        tel:'电话',
        referred_email:'推荐人邮箱',
        letter:'确认信',
        sendconfirmation:'确定重新发送确认信吗？',
        date_time:'订单时间',
        private:'私教课',
        activity:'活动',
        works:'作品',
        work_name:'作品名称',
        work_link:'作品链接',
        child_grade:'学生年级',
        child_age:'学生年龄',
        child_name:'学生姓名',
        discount_name:'使用优惠券名称',
        center:'学习中心',
        course_date_time:'课程开始时间',
        state:'状态',
        cancel:'取消',
        normal:'正常',
        refund_fee:'退费',
        suspend:'停课',
        first:'是否首次购买',
    },
    student_list:{
        course:'课程',
        parent_name:'家长姓名',
        email:'邮箱',
        tel:'电话',
        wechat:'微信号',
        name:'学生名称',
        student_id:'学生 ID',
        age:'年龄',
        remarks:'备注',
        parent_note:'家长备注',
        parent_id:'家长 ID',
        have_look:'是否看护',
        have_lunch:'是否午餐',
        edit_remarks:'修改备注',
        title:'邮件标题',
        old_course_id:'前课程ID',
        time:'时间',
        children_status:'学生状态',
        status0:'未点名',
        status1:'已到',
        status2:'未到',
        fields:'自定义字段',
        custom_edit:'自定义字段编辑',
        pay_price:'实际支付金额',
        per_class_price:'每课金额',
        custom_edit_price:'编辑金额',
        cn:'中国',
        en:'美国',
        remote_type:'报名来源',
    },
    mail:{
        title:'标题',
        type:'类型',
        content:'内容',
        is_default:'默认',
    },
    journal:{
        title:'日志',
        type:'类型',
        create_time:'操作时间',
        name:'名称',
        user_name:'操作人',
        admin_email:'账号邮箱',
        child_name:'学生名',
        score:'积分',
    },
    virtual:{
        subject:'主题',
        number:'人数',
        teacher:'老师',
        student:'学生',
        teacher_leave:'老师请假',
        student_leave:'学生请假',
        private:'公/私信',
        comment:'查看点评',
        chat:'师生交流',
        feedback:'意见反馈',
        adopt:'通过',
        reject:'驳回',
        time:'时间',
        reason:'理由',
        feedback_name:'用户',
        content:'内容',
        reply:'回复',
        open:'公开',
        on_open:'不公开',
        star:'星级',
        send:'发送',
        receive:'接收',
        status:'状态',
        change_teacher:'换老师',
        change_course:'换课',
        course:'课程列表',
        student_list:'学生列表',
        attendance:'出勤',
        task:'作业',
        arrived_num:'已到人数',
        not_arrived_num:'未到人数',
        task_name:'标题',
        task_content:'内容',
        task_file:'附件',
        parent:'家长',
        form:'评估表',
        certificate:'证书',
        remarks:'备注',
        seller:'销售',
        no:'序号',
        teacher_task:'老师留作业',
        student_task:'学生交作业',
        teacher_ratify_task:'老师批作业',
        teacher_on_task:'老师还没有留作业',
        leave:'请假',
        leave_reason:'请假原因',
        leave_time:'请假时间',
        del_student:'删除学生',
        user_tel:'家长电话',
        grade:'年级',
        age:'年龄',
        create_time:'申请时间',
        debate_evaluation:'辩论评估表',
    },
    virtualmaillist:{
        time:'时间',
        title:'标题',
        content:'内容',
        children:'用户',
        type:'类型',
        send_type:'发送方式',
        date:'原来的课程时间',
        change:'处理方案',
        preview:'预览',
    },
    certificate:{
        title:'标题',
        code:'标识',
        image:'证书',
    },
    feedback_index:{
        name:'用户名',
        email:'邮箱',
        tel:'电话',
        content:'反馈内容',
        create_time:'创建时间',
        status:'状态',
        no_reply:'未回复',
        replied:'已回复',
        reply_content:'回复内容',
        reply_success:'回复成功',
        remarks:'备注',
        history:'历史',
        coupon_list:'优惠券',
    },
    assess:{
        title:'听、说、读、写综合课程，增强年轻人的信心和领导力灯光、相机、行动！',
        student:'学生',
        teacher:'老师',
        class:'课程',
        location:'学习中心',
        time:'上课时间',
        session:'学期',
        notes:'教师评语',
        sound:'教师录音',
    },
    statistic_index:{
        date:'时间',
        teacher:'老师',
        class_num:'总课次',
        course:'课程',
        should:'应填写评测表',
        already:'已填写评测表',
    },
    student:{
        name:'评估表名称',
        status:'状态',
        reason:'驳回理由',
        date:'时间',
        teacher:'老师',
        operator:'操作人',
        reject:'驳回',
    },
    notice_index:{
        course:'课程名称',
        user_name:'用户名',
        tel:'手机号',
        type:'类型',
        date:'时间',
        status0:'未处理',
        status1:'已处理',
        status3:'已忽略',
        ignore:'忽略',
        confirm_delete:'确定忽略吗？',
    },
    coupon_index:{
        name:'优惠券名称',
        coupon_type:'优惠券类型',
        credit_amount:'抵值金额',
        discount:'折扣比',
        get_type:'领取方式',
        superposition:'可否叠加',
        binding_type:'绑定类型',
        binding:'绑定(不选是全选)',
        trigger_type:'领取触发类型',
        service_conditions:'使用条件',
        menkan:'满减金额条件（0无限制）',
        all_times:'使用次数（0无限制）',
        time_type:'时间类型',
        length:'时长（天）',
        time_length:'时长（分钟）',
        time:'时间区间',
        code:'领取码',
        status:'状态',
        shuoming:'使用说明',
        user_email:'用户邮箱',
        user_name:'用户账号',
        user_tel:'用户手机号',
        user_id:'用户 ID',
        order:'订单 ID',
        get_time:'领取时间',
        use_time:'使用时间',
        is_use:'是否使用',
        is_exclude:'不包括',
        is_discount:'比例折扣',
        no_diejia:'不叠加',
    },
    statistic_course:{
        max_people:'报名上限',
        student_num:'报名人数',
        baokelv:'报课率',
        coupon_price:'优惠金额',
        score:'使用积分',
        pay_price:'课程收入',
        number_courses_5:'5人及以上报名课程数量',
        use_5:'5人及以上报名课程积分',
        paid_5:'5人及以上报名课程收入',
        total_5:'5人及以上报名课程合计',
    },
    course_private:{
        title1:'老师时间',
        title2:'课程',
        purchased:'已购买',
        confirmed:'已确认',
        before:'当天之前',
        after:'当天之后',
    },
    sharing:{
        '公司名称':'公司名称',
        '分账账号':'分账账号',
        '分账比例':'分账比例',
        '是否启用':'是否启用',
        '最新启用时间':'最新启用时间',
        '实收':'实收',
        '元':'元',
    },
    ...zhLocale
}
export default cn;


// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js